import { ENDPOINT_BASE } from '@/config/endpoints'

const ATTACHMENTS_BASE = `${ENDPOINT_BASE}/e`

export const ENDPOINT_ATTACHMENTS = (
  workspaceId: string,
  entityType: string,
  entityId: string,
) =>
  `${ATTACHMENTS_BASE}/${workspaceId}/${entityType}/${entityId}/attachments`

export const ENDPOINT_ATTACHMENT = (
  workspaceId: string,
  attachmentId: string,
) =>
  `${ATTACHMENTS_BASE}/${workspaceId}/attachments/${attachmentId}`

export const ENDPOINT_ATTACHMENT_DOWNLOAD_URL = (
  workspaceId: string,
  attachmentId: string,
) =>
  `${ATTACHMENTS_BASE}/${workspaceId}/attachments/${attachmentId}/url`
